import { render, staticRenderFns } from "./UserCenterLayout.vue?vue&type=template&id=452aa05e"
import script from "./UserCenterLayout.vue?vue&type=script&lang=js"
export * from "./UserCenterLayout.vue?vue&type=script&lang=js"
import style0 from "./UserCenterLayout.vue?vue&type=style&index=0&id=452aa05e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports